<template>
  <div>
    <div class="app-container order-info">
    <el-form inline :model="orderInfo" label-width="100px">
      <div class="title">订单中心
        <el-button @click="backAndClose" style="float:right;">返回</el-button>
      </div>
      <div class="search-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item class="mb0 nowrap" label="订单编号：">
              <span>{{orderInfo.orderNo}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="mb0" label="订单状态：">
              <span>{{orderInfo.statusName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="mb0" label="创建时间：">
              <span>{{orderInfo.orderTime}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="mb0" label="联系人手机号：" label-width="110px">
              <span>{{orderInfo.contactMobile}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item class="mb0" label="订单金额：">
              <span>￥{{orderInfo.itemTotal || 0}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="mb0" label="实付金额：">
              <span>￥{{orderInfo.paymentTotal || 0}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="mb0" label="退款金额：">
              <span>￥{{orderInfo.refundAmount || 0}}</span>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item class="mb0" label="手续费：">
              <span>￥{{orderInfo.refundFee || 0}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-table class="ticket" border header-row-class-name='parent-head-style' :key='tableKey' :data='tripOrderTicketInfoDOList' v-loading.body='listLoading' fit highlight-current-row style='width: 100%'>
        <el-table-column v-if="orderInfo.status === 10 || orderInfo.status === 20 || orderInfo.status === 28" align='center' width="160" label='票号'>
            <template slot-scope='scope'>
                <span>{{scope.row.ticketNo}}</span>
            </template>
        </el-table-column>
          <el-table-column v-if="orderInfo.status === 10 || orderInfo.status === 20 || orderInfo.status === 28" align='center' width="160" label='验票二维码'>
            <template slot-scope='scope'>
                <img class="pointer" @click="qrCode(scope.row)" src="../assets/images/home/qccode.png" />
            </template>
        </el-table-column>
        <el-table-column align='center' label='有效日期' width="160">
            <template slot-scope='scope'>
                <span>{{scope.row.earliestEffectiveCheckDate}} - {{scope.row.lastEffectiveCheckDate}}</span>
            </template>
        </el-table-column>
        <!-- <el-table-column align='center' label='有效时间' width="160">
            <template slot-scope='scope'>
                <span>{{scope.row.earliestEffectiveCheckTime}} - {{scope.row.lastEffectiveCheckTime}}</span>
            </template>
        </el-table-column> -->
        <el-table-column align='center' label='姓名'>
            <template slot-scope='scope'>
                <span>{{scope.row.visitorName}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' width="150" label='证件号'>
            <template slot-scope='scope'>
                <span>{{scope.row.visitorCertificateNo}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' width="110" label='出行人手机号'>
            <template slot-scope='scope'>
                <span>{{scope.row.visitorMobile}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' label='人数' width="60">
            <template slot-scope='scope'>
                <span>{{scope.row.allowPersonCount}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' label='次数' width="60">
            <template slot-scope='scope'>
                <span>{{scope.row.allowEnterCount}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' width="130" label='取票日期'>
            <template slot-scope='scope'>
                <span>{{scope.row.ticketPickupTime}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' label='打印次数'>
            <template slot-scope='scope'>
                <span>{{scope.row.printCounts}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' label='已验次数'>
            <template slot-scope='scope'>
                <span>{{scope.row.checkedTicketCounts}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' label='取票状态'>
            <template slot-scope='scope'>
                <span>{{scope.row.pickupStatusName}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' label='票状态'>
            <template slot-scope='scope'>
                <span>{{scope.row.checkStatusName}}</span>
            </template>
        </el-table-column>
        <el-table-column align='center' fixed="right" label='操作' width='100'>
            <template slot-scope='scope'>
                <span class='blue pointer' @click="handleCheckInfo(scope.row)">检票记录</span>
            </template>
        </el-table-column>
    </el-table>

  </div>
  <div class="comp-box">
    <el-dialog title="检票信息" left :visible.sync="dialogCompVisible" class="dialog-p20" :modal-append-to-body="false">
      <el-form :model="form" ref="form" >
          <el-row class="mb0">
              <el-col :span="8">
                  <el-form-item  label="票号：">
                      <span>{{form.ticketNo}}</span>
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item  label="证件号：">
                      <span>{{form.visitorCertificateNo}}</span>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-table header-row-class-name='parent-head-style' :key='tableKey' :data='checkInfo' v-loading.body='listLoading' fit highlight-current-row style='width: 100%'>
              <el-table-column align='center' label='检票类型'>
                  <template slot-scope='scope'>
                      <span>{{scope.row.validationTypeName}}</span>
                  </template>
              </el-table-column>
              <el-table-column align='center' label='检票介质'>
                  <template slot-scope='scope'>
                      <span>{{scope.row.checkTypeName}}</span>
                  </template>
              </el-table-column>
              <el-table-column align='center' label='检票识别号' width="160">
                  <template slot-scope='scope'>
                      <span>{{scope.row.checkNo}}</span>
                  </template>
              </el-table-column>
              <!-- <el-table-column align='center' label='检票日期'>
                  <template slot-scope='scope'>
                      <span>{{scope.row.checkDate}}</span>
                  </template>
              </el-table-column> -->
              <el-table-column align='center' label='检票时间'>
                  <template slot-scope='scope'>
                      <span>{{scope.row.checkTime}}</span>
                  </template>
              </el-table-column>
              <el-table-column align='center' label='设备名称'>
                  <template slot-scope='scope'>
                      <span>{{scope.row.deviceName}}</span>
                  </template>
              </el-table-column>
              <el-table-column align='center' label='人数'>
                  <template slot-scope='scope'>
                      <span>{{scope.row.personCount}}</span>
                  </template>
              </el-table-column>
          </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">关闭</el-button>
      </div>
  </el-dialog>
  </div>

  <div class="qrcode-box" v-show="qrcode" @click="qrcode = false">
      <div class="qc-box-2">
        <div class="icon"><img src="../assets/images/home/whiteCode.png" /></div>
        <div class="title-text" v-if="qcCodeSelect">
          <p class="p1">{{qcCodeSelect.ticketName}}</p>
          <p class="p2">{{qcCodeSelect.ticketKindName}}</p>
          <p class="userName">{{qcCodeSelect.visitorName}}</p>
        </div>
        <div id="qrcode"  class="qrcode"></div>
        <div class="hint">提示:虚线框内为建议截图，拍照范围</div>
        <!-- <el-button @click="qrcode = false">关闭</el-button> -->
        <img class="closeIcon" @click="qrcode = false" src="../assets/images/home/close.png"/>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail, getTicketDetail, getCheckLogList } from '@/api/myOrder'
import { getCheckType, getDictList } from '@/api/buyTicket'
import QRCode from 'qrcodejs2'
export default {
  name: 'orderListDetail',
  data () {
    return {
      listLoading: false,
      orderInfo: {},
      tripOrderTicketInfoDOList: null,
      tableKey: 0,
      list: [],
      activeTabs: 'ticketInfo',
      dialogCompVisible: false,
      checkInfo: [],
      form: {},
      status: [],
      checkType: [],
      qrcode: false,
      qcCodeSelect: null
    }
  },
  props: ['orderNo'],
  created () {
    const orderNo = this.orderNo
    this.handleQueryDetail(orderNo)
    // this.getTicketDetail(orderNo)
  },
  computed: {},
  components: {},
  methods: {
    // 数据字典
    getDictList (option, typeCode) {
      getDictList(typeCode).then(res => {
        if (res.code === 0) {
          this[option] = res.data
        }
      })
    },
    // 获取检票介质
    getCheckType () {
      getCheckType().then(res => {
        if (res.code === 0) {
          this.checkType = res.data
        }
      })
    },
    handleQueryDetail (orderNo) {
      getDetail(orderNo).then(res => {
        if (res.code === 0) {
          this.orderInfo = res.data
          this.tripOrderTicketInfoDOList = res.data.tripOwTicketInfoList
        } else {
          this.$message.error('请求出错了')
        }
      })
    },
    getTicketDetail (orderNo) {
      getTicketDetail({
        orderNo
      }).then(res => {
        if (res.code === 0) {
          this.tripOrderTicketInfoDOList = res.data
        }
      })
    },
    handleReturn () {
      this.$router.push({
        path: 'orderList'
      })
    },
    handleCheckInfo (record) {
      this.dialogCompVisible = true
      this.form = {
        ticketNo: record.ticketNo,
        visitorCertificateNo: record.visitorCertificateNo
      }
      getCheckLogList(record.ticketId).then(res => {
        console.log(res, 'resa')
        if (res) {
          this.checkInfo = res
        }
      })
    },
    backAndClose () {
      this.$emit('backAndClose')
    },
    cancel () {
      this.dialogCompVisible = false
      this.checkInfo = []
      this.form = {}
    },
    qrCode (row) {
      this.qcCodeSelect = row
      document.getElementById('qrcode').innerHTML = ''
      let qrcode = new QRCode('qrcode', {
        width: 200, // 图像宽度
        height: 200, // 图像高度
        colorDark: '#000000', // 前景色
        colorLight: '#ffffff', // 背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H // 容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      })
      qrcode.clear() // 清除二维码
      qrcode.makeCode(row.ticketNo) // 生成另一个新的二维码

      //
      let qrcodeChange = document.getElementById('qrcode').getElementsByTagName('img')[0]
      let name = document.createElement('div')
      name.innerText = row.visitorName
      name.style.cssText = 'margin-top: 50px;'
      qrcodeChange.parentNode.insertBefore(name, qrcodeChange.nextSibling)
      //
      this.qrcode = true
    }
  }
}
</script>
<style lang="scss" scoped>
.order-info{

  form{
    .search-form-inline{
      border: 1px solid #EBEEF5;
      margin: 40px auto;
      margin-top: 5px;
    }
  }
}
.ticket{
    margin: 0 auto;
}
.title {
    position: relative;
    font-size: 18px;
    line-height: 65px;
    padding-left: 25px;
    font-weight: bold;
    margin: 0 auto;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      width: 5px;
      height: 28px;
      background: #c09430;
      content: "";
      margin-top: -14px;
    }
  }
  .comp-box {
    /deep/.v-modal {
      width: calc(100% + 264px);
    }
    .dialog-p20 {
      width: calc(100% + 264px);
    }
  }
  .qrcode-box{
    width: calc(100% + 264px);
    height: 100%;
    z-index: 1000;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    .qc-box-2{
      position: relative;
      width: 375px;
      height: 618px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 12px;
      margin: 100px auto;
      .userName{
        position: absolute;
        top: 400px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
      }
      .hint{
        width: 100%;
        position: absolute;
        bottom: 87px;
        left: 50%;
        transform: translateX(-50%);
        color: #E34E4E;
        opacity: 1;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
      }
      .icon {
        width: 92px;
        height: 92px;
        background: #71A6FA;
        border: 3px solid #FFFFFF;
        box-shadow: 0px 3px 6px rgba(41, 46, 52, 0.08);
        border-radius: 50%;
        opacity: 1;
        position: absolute;
        top: -46px;
        left: 50%;
        transform: translateX(-50%);
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .title-text {
        position: absolute;
        top: 62px;
        left: 50%;
        transform: translateX(-50%);
        .p1 {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #0D1720;
        }
        .p2 {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
    .qrcode{
      background: #fff;
      width: 200px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 67px 45px;
      border:  1px dashed #707070;
      img {
        border: 1px solid #707070;
      }
    }
    .closeIcon {
      position: absolute;
      bottom: 15px;
      left: 50%;
      width: 40px;
      height: 40px;
      transform: translateX(-50%);
      cursor: pointer;
    }
  }
  .pointer{
    cursor: pointer;
  }
</style>
